// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"_32bbee5fda--wrapper--C1mw7","wrapper_redesign":"_32bbee5fda--wrapper_redesign--dDzY3"};